/**
 * API Configuration
 * Hỗ trợ cả client-side và server-side rendering
 */

// URL cho client-side (browser)
const BACKEND_HEAD = process.env.NEXT_PUBLIC_BASE_URL || 'http://localhost:7001';

// URL cho server-side (SSR) - có thể là internal URL hoặc localhost
const BACKEND_INTERNAL_HEAD = process.env.BACKEND_INTERNAL_URL || 'http://localhost:7001';

/**
 * Base URL cho API requests
 * - Client-side: sử dụng NEXT_PUBLIC_BASE_URL
 * - Server-side: sử dụng BACKEND_INTERNAL_URL (hoặc fallback về localhost)
 */
export const API_HEAD =
  typeof window !== 'undefined'
    ? BACKEND_HEAD + '/api/'
    : BACKEND_INTERNAL_HEAD + '/api/';

/**
 * Base URL không có /api/ để sử dụng cho các trường hợp đặc biệt
 */
export const BASE_URL =
  typeof window !== 'undefined'
    ? BACKEND_HEAD
    : BACKEND_INTERNAL_HEAD;
